import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'rc-dropdown';

import { useDispatch, useSelector } from 'react-redux';
import { clientApi } from 'helpers/api/client';
import { Cancelation } from 'store/requestsCancellation/actions';
import { useFirstRender } from 'hooks/useFirstRender';
import { userDataSelector } from 'store/auth/selectors';

import { Loader } from 'components/Loader';
import { Icon } from 'components/Icon';
import { ModalClient } from 'components/ModalClient';
import { useHistory } from 'react-router-dom';
import { ModalCreateClient } from 'components/ModalCreateClient/ModalCreateClient';
import { ModalStatistic } from 'components/ModalStatistic';
import { ModalStatisticReservation } from 'components/ModalStatisticReservation/ModalStatisticReservation';
import { ModalStatisticRejectReason } from 'components/ModalStatisticRejectReason/ModalStatisticRejectReason';
import { ModalStatisticFeedback } from 'components/ModalStatisticFeedback/ModalStatisticFeedback';
import { ModalStatisticInterest } from 'components/ModalStatisticInterest/ModalStatisticInterest';

import 'rc-dropdown/assets/index.css';
import { actStatusesSelector } from 'store/transferAct/selectors';
import { ModalInstrumentsMainPage } from 'components/ModalInstruments/ModalInstrumentsMainPage';

const Navbar = ({ list, active, onClick, setIsTable, setItem, item, itemQueryParam }) => {
  const userData = useSelector(userDataSelector);
  const statusList = useSelector(actStatusesSelector);

  const menuRef = useRef(null);
  const firstRender = useFirstRender();
  const searchString = new URLSearchParams(window.location.search).get('search') || '';
  const clientNumber = new URLSearchParams(window.location.search).get('clientNumber') || '';
  const history = useHistory();
  const dispatch = useDispatch();
  const [pending, setPending] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const [modalStatistic, setModalStatistic] = useState(false);
  const [modalStatisticRejectReason, setModalStatisticRejectReason] = useState(false);

  const [modalStatisticReservation, setModalStatisticReservation] = useState(false);
  const [modalStatisticInterest, setModalStatisticInterest] = useState(false);
  const [modalStatisticFeedback, setModalStatisticFeedback] = useState(false);

  const [modalClient, setModalClient] = useState(!!searchString);
  const [modalCreateClient, setModalCreateClient] = useState(!!clientNumber);
  const [modalInstruments, setModalInstruments] = useState(false);

  useEffect(() => {
    if (
      firstRender ||
      (!item && itemQueryParam) ||
      statusList.length === 0 ||
      Object.keys(active).length === 0 ||
      modalClient
    ) {
      return;
    }

    dispatch(Cancelation.cancelPendingRequests());
  }, [active]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  const handleClick = (link) => {
    return onClick && onClick(link);
  };

  const handleModalStatistic = () => {
    setModalStatistic(!modalStatistic);
  };

  const handleModalStatisticRejectReason = () => {
    setModalStatisticRejectReason(!modalStatisticRejectReason);
  };

  const handleModalStatisticReservation = () => {
    setModalStatisticReservation(!modalStatisticReservation);
  };

  const handleModalStatisticInterest = () => {
    setModalStatisticInterest(!modalStatisticInterest);
  };

  const handleModalStatisticFeedback = () => {
    setModalStatisticFeedback(!modalStatisticFeedback);
  };

  const handleCreateClient = async (data) => {
    if (pending) {
      return;
    }
    data.individual = true;
    setPending(true);
    const { data: client } = await clientApi.createClient(data);
    setPending(false);
    return client;
  };

  const handleModalClient = () => {
    setModalClient(!modalClient);
    history.push({ search: '' });
  };

  const toggleCreateClientModal = (toggle) => {
    setModalCreateClient(toggle);
    history.push({ search: '' });
  };

  const handleModalInstruments = () => {
    setModalInstruments(!modalInstruments);
  };

  const handleShowMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleMenuClick = ({ key }) => {
    handleShowMenu(false);

    switch (key) {
      case '1':
        return setModalStatistic(true);
      case '2':
        return setModalStatisticReservation(true);
      case '3':
        return setModalStatisticInterest(true);
      case '4':
        return setModalStatisticFeedback(true);
      case '5':
        return setModalStatisticRejectReason(true);
    }
  };

  return (
    <nav className="nav">
      <div className="nav-header">
        <img className="nav-logo" alt="Logo" src="images/logo.png" />
      </div>

      <div className="nav-menu scrollable">
        {list && userData.position === 'Менеджер колл-центра' && (
          <div
            className="nav-link"
            onClick={() => handleClick({ stockName: 'Все склады' })}
            active={active.stockID1C === undefined ? 'true' : undefined}
          >
            Все склады
          </div>
        )}

        {list &&
          list.map((el) => (
            <div
              key={el.stockID1C}
              className="nav-link"
              onClick={() => handleClick(el)}
              active={active.stockID1C === el.stockID1C ? 'true' : undefined}
            >
              {el.stockName}{' '}
              {!!el.reserve_client_front_count && <div className="nav-count">{el.reserve_client_front_count}</div>}
            </div>
          ))}
        {!list && <Loader type="small" color="#000" />}
      </div>

      <div className="nav-modals">
        <div className="child">
          <Dropdown
            placement="topRight"
            visible={showMenu}
            overlay={
              <ul className="statistic-menu" ref={menuRef}>
                <li onClick={() => handleMenuClick({ key: '1' })}>Статистика сервиса для клиентов</li>
                <li onClick={() => handleMenuClick({ key: '2' })}>Статистика резервов</li>
                <li onClick={() => handleMenuClick({ key: '3' })}>Статистика интересов клиентов</li>
                <li onClick={() => handleMenuClick({ key: '4' })}>Статистика отзывов клиентов</li>
                <li onClick={() => handleMenuClick({ key: '5' })}>Статистика отклоненных резервов</li>
              </ul>
            }
          >
            <Icon name="statistic" style={{ cursor: 'pointer' }} tooltipText="Статистика" onClick={handleShowMenu} />
          </Dropdown>
        </div>
        <div className="child"></div>
        <div className="child">
          <Icon name="user-big" style={{ cursor: 'pointer' }} tooltipText="Контрагенты" onClick={handleModalClient} />
        </div>
        <div className="child">
          <Icon
            name="instrument-big"
            style={{ cursor: 'pointer' }}
            onClick={handleModalInstruments}
            tooltipText="Номенклатура"
          />
        </div>
      </div>
      {modalStatistic && <ModalStatistic onClose={handleModalStatistic} />}
      {modalStatisticReservation && <ModalStatisticReservation onClose={handleModalStatisticReservation} />}
      {modalStatisticRejectReason && <ModalStatisticRejectReason onClose={handleModalStatisticRejectReason} />}
      {modalStatisticInterest && <ModalStatisticInterest onClose={handleModalStatisticInterest} />}
      {modalStatisticFeedback && <ModalStatisticFeedback onClose={handleModalStatisticFeedback} />}
      {modalClient && (
        <ModalClient
          disableSelectable={true}
          onClose={handleModalClient}
          searchString={searchString}
          isFromMainPage={true}
        />
      )}
      {modalCreateClient && (
        <ModalCreateClient
          onSubmit={handleCreateClient}
          onClose={() => toggleCreateClientModal(false)}
          type={'individ'}
          clientNumber={clientNumber}
        />
      )}

      {modalInstruments && (
        <ModalInstrumentsMainPage
          disableSelectable={true}
          onClose={handleModalInstruments}
          setIsTable={setIsTable}
          setItem={setItem}
        />
      )}
    </nav>
  );
};

Navbar.propTypes = {
  active: PropTypes.object,
  list: PropTypes.any,
  onClick: PropTypes.func,
  setIsTable: PropTypes.func,
  setItem: PropTypes.func,
  item: PropTypes.object,
  itemQueryParam: PropTypes.string,
};

Navbar.defaultProps = {
  active: {},
  list: [],
};

export { Navbar };
